import { CreateTemplate } from "components/CreateTemplate";
import { Container, Content, PageSidebar } from "pages/Users/styles";
import { LoggedUser } from "components/LoggedUser";
import { TemplatesTable } from "components/TemplatesTable";
import { useAuth } from "hooks/useAuth";
import { AdminList } from "types/User";

export function Templates() {
  const { user } = useAuth();

  if (user == null || !AdminList.includes(user.name)) {
    return (
      <Container>
        <Content>
          <PageSidebar>
            <LoggedUser />
          </PageSidebar>
          <div style={{ alignSelf: "center", justifySelf: "center" }}>
            <h2>Você não tem permissão para acessar essa página!</h2>
          </div>
        </Content>
      </Container>
    );
  }

  return (
    <Container>
      <Content>
        <PageSidebar>
          <LoggedUser />
          <CreateTemplate />
        </PageSidebar>
        <TemplatesTable />
      </Content>
    </Container>
  );
}
